import { PaymentMethodEnum } from '@systemeio/ui'

export const allowedPaymentMethodsFunnels = Object.values(PaymentMethodEnum).filter(
  pm => pm !== PaymentMethodEnum.stripe_klarna,
)
